(function(){
'use strict';

angular.module('classy.frs').run(['$templateCache', function ($templateCache) {
  $templateCache.put('frs/shared/supporter/header/url-copy', '<div class="supporter-dashboard_header-social-link">\n' + '  <div class="supporter-dashboard_header-social-link-input"><span ng-bind="shareUrl"></span></div>\n' + '</div>\n' + '');
}]);
})();